import { fadeIn } from "ui/theme/keyframes";
import { spacing } from "ui/theme/utils";

const { default: styled, css } = require("styled-components");
const { Container } = require("ui/components/styled");

export const RelativeContainer = styled(Container)`
  position: relative;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ flexGrow }) => flexGrow && `flex-grow: ${flexGrow};`}
  ${(props) => spacing(props)}
`;

export const DropdownContainer = styled.div`
  position: absolute;
  background-color: white;
  font-size: 12px;
  width: 100%;
  top: calc(100% + 2px);
  box-shadow: 0px 0px 7px #e6e6e6;
  z-index: 10;
`;

export const DropDownItem = styled(Container)`
  border-bottom: 1px solid #e6e6e6;
  ${(props) => spacing(props)}
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
  }
`;

export const SearchIcon = styled.img.attrs(() => ({
  src: '/assets/img/icons/search.svg',
  alt: 'search',
}))`
  ${({ animated }) =>
    animated &&
    css`
      animation: ${fadeIn} 300ms ease-in;
    `}
  position: absolute;
  top: 15px;
  right: 10px;
  width: 20px;
`;

export const TagContainer = styled(Container)`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: max-content;
  font-size: 10px;
  gap: 4px;
  padding: 4px;
  padding-right: 15px;
  ${({ isCompleted, theme: { colors } }) =>
    isCompleted &&
    `
  border: 1px solid ${colors.primary};
  border-radius: 4px;
  background-color: ${colors.quaternary};
  color: ${colors.primary};
  `}
`;

export const TagsContainer = styled(Container)`
  flex-direction: row;
  gap: 4px;
  box-shadow: 0px 1px 6px rgb(0 0 0 / 16%);
  background-color: white;
  padding: 11px;
  border-radius: 8px;
  border: none;
  width: 100%;
  max-width: 100%;
  text-align: left;
  letter-spacing: 0.62px;
  color: #888;
  font-weight: 400;
  font-size: 13px;
  padding-right: 40px;
`;
